import { render, staticRenderFns } from "./SignBatchPage.vue?vue&type=template&id=0f0dd7a5&scoped=true"
import script from "./SignBatchPage.vue?vue&type=script&lang=js"
export * from "./SignBatchPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0dd7a5",
  null
  
)

export default component.exports